$(document).ready(function() {
  $(".search_input").click(function(){
        $(this).attr("placeholder", "");
    });
  $(".search_input").blur(function(){
        $(this).attr("placeholder", "Pretražite proizvode prema njihovom nazivu");
    });

  // $(".options_menus h4").click(function(){
  //   if($(".options_menus form").css("display") == "flex") {
  //     $(".options_menus form").css("display", "none");
  //   } else {
  //     $(".options_menus form").css("display", "flex");
  //   }
  // })
});



// WEBPACK FOOTER //
// app/frontend/javascripts/search_bar_focus.js